module.exports = __webpack_public_path__ + "static/media/CS3 -- 7.2036cf19.JPG";